/** Catalogue types for themes, assets and adjustment presets. */
import type { Adjustments, Background } from '@freealbum/document';

export type AssetKind = 'stickers' | 'backgrounds';

/** Theme ids that ship with the product. Custom themes may use any id. */
export type ThemeId = 'family' | 'wedding' | 'travel' | 'baby' | 'plain';

export interface ThemePack {
  id: string;
  /** i18n key under `themes.*` */
  nameKey: string;
  /** 5 colours: [0] page background, [1] text, [2..4] accents */
  palette: string[];
  /** must be a family in @freealbum/text that supports Hebrew + nikud */
  headingFont: string;
  bodyFont: string;
  coverBackground: Background;
  pageBackground: Background;
  /** sticker/background tags that belong to this theme */
  stickerTags: string[];
}

export interface StickerAsset {
  id: string;
  /** i18n key under `stickers.*` */
  nameKey: string;
  tags: string[];
  /** URL path served by the app: /assets/stickers/{id}.svg */
  path: string;
  /** width / height of the artwork, used to size a newly dropped sticker */
  aspect: number;
}

export interface BackgroundAsset {
  id: string;
  /** i18n key under `backgrounds.*` */
  nameKey: string;
  tags: string[];
  path: string;
  /** how the asset is meant to be painted (see Background.mode in @freealbum/document) */
  mode: 'tile' | 'cover';
}

export interface AdjustmentPreset {
  id: string;
  /** i18n key under `adjustments.*` */
  nameKey: string;
  adjustments: Adjustments;
}
